import React from 'react';
import { EmptySearchColor as EmptySearchColorIcon } from 'patternx-svg';
import { Empty } from 'antd';
import './index.less';

interface IStateEmpty {
  title: string;
  desc: string;
}

const FindEmptyInfo: React.FC<IStateEmpty> = (props) => {
  const { title, desc } = props;
  return (
    <div className="empty-wrap">
      <Empty
        image={<EmptySearchColorIcon size={200} />}
        imageStyle={{
          width: 200,
          height: 200,
        }}
        description={
          <>
            <div className="empty-title" style={{ marginTop: 8 }}>
              {title}
            </div>
            <div className="empty-desc">{desc}</div>
          </>
        }
      />
    </div>
  );
};

export default React.memo(FindEmptyInfo);
